import { CommonError, DisabledOpacity, MockupLoader } from "components/utils";
import { DrawerRightPanel, RightPanelBody } from "components/utils/drawer";
import { useQuery } from "hooks";
import { useDrawer } from "hooks/useDrawer";
import { assertIsDefined } from "utilities/assertIsDefined";
import { TitleSection } from "./titleSection/TitleSection";
import { GeneralInfoSection } from "./generalInfoSection/GeneralInfoSection";
import { PanelHeader } from "./panelHeader/PanelHeader";
import { wmsRampActions } from "api/wms/ramps/actions";

export const RightPanel = () => {
  const { query } = useQuery();
  const { close } = useDrawer("wmsRamps");
  const { panelId } = query;
  const { data: ramp, error, isLoading } = wmsRampActions.useGetRamp(panelId, {
    enabled: Boolean(panelId),
  });

  if (error) {
    return (
      <DrawerRightPanel className="position-static">
        <CommonError status={error._httpStatus_} />
      </DrawerRightPanel>
    );
  }

  if (isLoading) {
    return (
      <DrawerRightPanel className="position-static">
        <div className="overflow-hidden h-100 position-relative">
          <MockupLoader type="drawer" />
        </div>
      </DrawerRightPanel>
    );
  }

  if (!panelId) return null;

  assertIsDefined(ramp);

  return (
    <DrawerRightPanel className="position-relative" key={panelId}>
      <PanelHeader close={close} ramp={ramp} />
      <DisabledOpacity disabled={isLoading}>
        <RightPanelBody>
          <TitleSection ramp={ramp} />
          <GeneralInfoSection ramp={ramp} />
        </RightPanelBody>
      </DisabledOpacity>
    </DrawerRightPanel>
  );
};
